<di-search
           title="Currency"
           searchPlaceholder="Search"
           [columns]="columns"
           [pageDTO]="pageDTO">

</di-search>